<script lang="ts">
  import Autocomplete from "@shared/svelte/Components/Autocomplete.svelte";
  import CustomerServiceCheckbox from "@shared/svelte/Components/CustomerServiceCheckbox.svelte";
  import type { Distributor } from "@shared/types/Distributor";
  import type { SalesRep } from "@shared/types/SalesRep";
  import ChatWithSupportLink from "@shared/svelte/Components/ChatWithSupportLink.svelte";
  import _ from "lodash";

  export let selectedDistributor: Distributor;
  export let showAddManualControl: boolean;
  export let nonCSReps: any[];
  export let ordersFromCustomerService: boolean;
  export let useCustomerService: (e: any) => void;
  export let suggestedReps: any[];
  export let selectedReps: any[];
  export let manualRep: () => void;
  export let updateSelectedReps: (e: any) => void;
  export let addSelectedRepFromSuggested: (rep: SalesRep) => void;
  export let closeModal: () => void;

</script>

{#if selectedDistributor.account_number && !showAddManualControl}
  <div class="grid-row margin-top--small">
    <div class="grid-col c12-12">
      <div class="default-body--bold">Account Number</div>
    </div>
    <div class="grid-col c12-12 margin-top--smaller">
      <div class="default-body--regular">
        {selectedDistributor.account_number}
      </div>
    </div>
  </div>
{/if}

<div class="grid-row margin-top--small">
  <div class="grid-col c12-12">
    <div class="default-body--bold">
      Search for your {selectedDistributor.name} Sales Reps or
      <span
        on:click={manualRep}
        class="cursor-pointer color-brandSecondary add-manual-link underline-hover default-body--bold"
        >add them manually</span
      >
    </div>
  </div>
  <div class="grid-col c12-12 margin-top--smaller sales-rep-autocomplete">
    <Autocomplete
      addFromAutocompleteOnly={true}
      placeholder="Search for reps"
      objectType="sales_rep"
      searchUrlInput={`/api/retailer/distributors/${selectedDistributor.id}/sales_reps`}
      apiParams={{ search: true, show_assignments: true }}
      bind:value={nonCSReps}
      on:tagAdded={updateSelectedReps}
      on:tagRemoved={updateSelectedReps}
      listMode={true}
    />
  </div>
</div>

{#if selectedDistributor.customer_service_rep_id}
  <div class="padding-top--smaller fizz-styles">
    <CustomerServiceCheckbox
      {ordersFromCustomerService}
      distributorId={selectedDistributor.id}
      {useCustomerService}
    />
  </div>
{/if}

{#if suggestedReps.length > 0}
  <div class="grid-row margin-top--small">
    <div class="grid-col c12-12">
      <div class="default-body--bold">Businesses near you order from these reps:</div>
    </div>
    <div class="grid-col c12-12 margin-top--smaller">
      {#each suggestedReps as rep}
        {#if !_.find(selectedReps, { id: rep.id })}
          <div class="default-body--regular grid-row">
            <div
              class="grid-col c10-12 underline-hover cursor-pointer color-brandPrimary"
              on:click={event => addSelectedRepFromSuggested(rep)}
            >
              {rep.name} - {rep.sanitized_email || ""}
            </div>
            <div class="grid-col c2-12">
              <span
                class="cursor-pointer underline-hover color-brandPrimary float-right"
                on:click={event => addSelectedRepFromSuggested(rep)}
              >
                Add
              </span>
            </div>
          </div>
        {/if}
      {/each}
    </div>
  </div>
{/if}

{#if !selectedReps.length}
  <div class="grid-row margin-top--small">
    <div class="grid-col c12-12 align-center">
      <div class="default-body--default align-center">
        Don't know your sales rep? <ChatWithSupportLink
          message="We can help."
          onClick={closeModal}
        />
      </div>
    </div>
  </div>
{/if}
